import React, { Component } from "react";
import {
  View,
  StyleSheet,
  TouchableHighlight,
  Platform,
  Linking,
} from "react-native";
import Text from "../../components_v2/TextFont";
import { translate } from "../../locales/translate";
import FontAwesomeIcon from "../../components_v2/FontAwesomeIcon";
import ArTheme from "../../argon-ui/Theme";
import { faAngleDoubleDown} from "../../../assets/consts/faCharCodes";
import InputSpinner from "react-native-input-spinner";
import Select from "../../nativeBase-ui/Select";


// import argonTheme from "./Theme";

class CreditCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedItem: false,
      newOrderUnitId: null,
      userAmount: this.props.baseAmount,
      newOrderUnitId: null,
      amountType: "thousand",
    };
  }
  setAmount(amount) {
    this.setState({ userAmount: amount }, () => {
      this.props.selectAmount && this.props.selectAmount(this.state.userAmount);
    });
  }
  setUnit(unitCode) {
    var unitLabel = "";

    for (var k in this.props.areaList) {
      if (this.props.areaList[k].value == unitCode) {
        unitLabel = this.props.areaList[k].label;
        break;
      }
    }
    this.setState(
      { newOrderUnitId: unitCode },
      this.props.selectUnit && this.props.selectUnit(unitCode, unitLabel)
    );
  }

  onPressOnlinePayment(showAlert = true) {
    var strAmountLength = this.props.userAmount.toString().length;
    var amountType = "";
    if (strAmountLength == 2 || strAmountLength == 3) {
      amountType = "thousand";
    } else if (
      strAmountLength == 4 ||
      strAmountLength == 5 ||
      strAmountLength == 6
    ) {
      amountType = "million";
    }
    this.props.onPressOnlinePayment &&
      this.props.onPressOnlinePayment(amountType, showAlert);
    this.setState({ amountType: amountType });
  }

  renderSpinnerPriceUnit = () => {
    return (
      <Text style={{ textAlign: "right" }}>
        ({translate("increaseCredit.thousand")} {translate("api.priceUnit")})
      </Text>
    );
  };

  render() {
    return (
      <View style={style.creditStyle}>
        <Text style={style.title}>{this.props.title}</Text>
        {this.props.creditUnitsAmount?.map((o, i) => {
          return (
            <View
              key={i}
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                height: Platform.OS == "web" ? 50 : 30,
                marginTop: 8,
                paddingStart: Platform.OS == "web" ? 0 : 8,
                marginBottom: 3,
              }}
            >
              <Text key={i} style={style.infoText}>
                {this.props.amountText} {o.label}
              </Text>
              <View style={{ flexDirection: "row", marginEnd: 14 }}>
                <Text style={style.amountText}>{o.amount}</Text>
                <Text style={style.amountText}>
                  {translate("api.priceUnit")}
                </Text>
              </View>
            </View>
          );
        })}
        {this.props.creditUserAmount != undefined && (
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              // height: 50,
              marginTop: 8,
              marginBottom: 3,
              paddingStart: Platform.OS == "web" ? 0 : 8,
            }}
          >
            <Text style={style.infoText}>{this.props.amountText}</Text>
            <View style={{ flexDirection: "row", marginEnd: 14 }}>
              <Text style={style.amountText}>
                {this.props.creditUserAmount}
              </Text>
              <Text style={style.amountText}>{translate("api.priceUnit")}</Text>
            </View>
          </View>
        )}
        <View
          style={{
            justifyContent: "flex-end",
            alignItems: "flex-end",
            marginEnd: 14,
            marginBottom: 13,
            paddingTop: 10,
            // marginBottom: 30,
            // paddingBottom:50,
            // flex: 1,
          }}
        >
          <TouchableHighlight
            underlayColor={ArTheme.COLORS.BORDER}
            onPress={() => {
              this.setState({ selectedItem: !this.state.selectedItem });
              if (!this.props.onlineGateway) {
                this.onPressOnlinePayment(null, false);
              }
            }}
            style={{
              borderColor: ArTheme.COLORS.BORDER,
              borderWidth: 1,
              backgroundColor: "#fff",
              borderRadius: 3,
              height: 37,
              padding: 9,
              width: 150,
              display: !this.state.selectedItem ? "flex" : "none",
            }}
          >
            <View
              style={{
                justifyContent: "space-between",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <View
                style={{
                  flex: 1,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Text style={{ textAlign: "center" }}>
                  {translate("increaseCredit.titleConfirm")}
                </Text>
              </View>
              <FontAwesomeIcon
                icon={faAngleDoubleDown}
                color="#808080"
                size={18}
              />
            </View>
          </TouchableHighlight>
        </View>
        <View
          style={{
            justifyContent: "flex-end",
            alignItems: "flex-end",
            marginEnd: 14,
            marginBottom: 15,
            marginTop: -10,
          }}
        >
          {this.state.selectedItem && (
            <View
              style={{
                flexDirection: "column",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  width: "100%",
                  paddingStart: 8,
                  // height: 44,
                  // flex:1
                }}
              >
                {Array.isArray(this.props.areaList) && (
                  <View style={{ width: 150 }}>
                    <Select
                      label={null}
                      data={this.props.areaList}
                      value={
                        Platform.OS == "web"
                          ? this.state.newOrderUnitId
                          : translate("api.orderUnit") ||
                            this.state.newOrderUnitId
                      }
                      onChangeText={(value, index, data) => {
                        if (Number.isInteger(value) || Number(value) > 0) {
                          this.setUnit(value);
                        }
                      }}
                    />
                  </View>
                )}
                {!Array.isArray(this.props.areaList) && (
                  <View
                    style={{
                      flexDirection: "row",
                      marginStart: -5,
                      paddingTop: 3,
                    }}
                  >
                    <Text style={{ fontSize: 20 }}>
                      {translate("increaseCredit.creditAmount")}
                    </Text>
                    <Text
                      style={{ fontSize: 17, paddingTop: 2, paddingStart: 2 }}
                    >
                      {"("}
                      {translate(`increaseCredit.${this.state.amountType}`)}
                      {translate("api.priceUnit")}
                      {")"}
                      {" :"}
                    </Text>
                  </View>
                )}
                <View>
                  <InputSpinner
                    value={this.props.userAmount}
                    onChange={(value) => this.setAmount(value)}
                    min={this.props.baseAmount}
                    step={this.props.baseAmount}
                    skin="round"
                    buttonFontSize={14}
                    fontSize={14}
                    style={{
                      height: 8,
                      width: 130,
                      marginStart: 5,
                      marginEnd: 5,
                    }}
                    height={34}
                    width={130}
                    editable={false}
                  />
                  {this.renderSpinnerPriceUnit()}
                </View>
              </View>
              <View
                style={{
                  paddingBottom: 2,
                  alignItems: "center",
                  marginTop: 20,
                }}
              >
                {!this.props.onlineGateway && (
                  <TouchableHighlight
                    underlayColor={ArTheme.COLORS.BORDER}
                    onPress={() => {
                      this.onPressOnlinePayment();
                    }}
                    style={{
                      borderColor: ArTheme.COLORS.BORDER,
                      borderWidth: 1,
                      backgroundColor: "#fff",
                      borderRadius: 3,
                      height: 37,
                      padding: 9,
                      width: 150,
                    }}
                  >
                    <Text style={{ textAlign: "center" }}>
                      {translate("api.onlinePayment")}
                    </Text>
                  </TouchableHighlight>
                )}
                {this.props.onlineGateway && (
                  <TouchableHighlight
                    underlayColor={ArTheme.COLORS.BORDER}
                    onPress={() => {
                      if (Platform.OS === "web") {
                        window.open(this.props.onlineUrl);
                      } else {
                        Linking.openURL(this.props.onlineUrl);
                      }
                    }}
                    style={{
                      borderColor: ArTheme.COLORS.BORDER,
                      borderWidth: 1,
                      backgroundColor: "#fff",
                      borderRadius: 3,
                      height: 37,
                      padding: 9,
                      width: 200,
                    }}
                  >
                    <Text style={{ textAlign: "center" }}>
                      {translate("api.onlinepaymentGetway")}
                    </Text>
                  </TouchableHighlight>
                )}
              </View>
            </View>
          )}
        </View>
      </View>
    );
  }
}
const style = StyleSheet.create({
  creditStyle: {
    flexDirection: "column",
    backgroundColor: "#fff",
    // flex: 1,
    borderColor: "#5b5b5a",
    borderRadius: 8,
    borderWidth: 1,
    justifyContent: "space-between",
    // minHeight: 350,
    alignItems: "stretch",
    marginBottom: 8,
    marginStart: 7,
    marginEnd: 7,
    marginTop: 7,
  },
  title: {
    fontWeight: "bold",
    fontSize: 20,
    paddingBottom: 7,
    // paddingTop: 5,
    backgroundColor: "#C0C0C0",
    paddingStart: 8,
    paddingEnd: 5,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
  },
  body: {
    justifyContent: "space-evenly",
  },
  amountText: { fontWeight: "bold", fontSize: 18 },
  infoText: { fontSize: 20, paddingStart: 8 },
});
export default CreditCard;
